import { render, staticRenderFns, recyclableRender, components } from "./message.vue?vue&type=template&id=15f611e9&scoped=true&"
var renderjs
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"
import style0 from "./message.vue?vue&type=style&index=0&lang=css&"
import style1 from "./message.vue?vue&type=style&index=1&id=15f611e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f611e9",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "shop/pages/message/message.vue"
export default component.exports